import { Svg, Path, type SvgProps, Circle } from 'react-native-svg'

export function LowesPlus(props: SvgProps) {
  return (
    <Svg width={12} height={12} viewBox="0 0 12 12" fill="none" {...props}>
      <Path
        d="M6.00027 1.99609L6.00027 9.39549M9.11138 5.69579L2.88916 5.69579"
        stroke={props.color ?? '#012FA6'}
        strokeWidth={1.5}
        strokeLinecap="round"
      />
      <Circle cx="6" cy="6" r="6" fill="#95CAE9" />
      <Path
        d="M6.00027 2.88672L6.00027 9.10894M9.11138 5.99783L2.88916 5.99783"
        stroke={props.color ?? '#012FA6'}
        strokeWidth={1.5}
        strokeLinecap="round"
      />
    </Svg>
  )
}
